import {
  Accordion,
  ActionIcon,
  Blockquote,
  Button,
  Divider,
  Grid,
  Group,
  HoverCard,
  Image,
  LoadingOverlay,
  Paper,
  SimpleGrid,
  Stack,
  Text,
  TextInput,
  ThemeIcon,
} from "@mantine/core";
import { useLanguage } from "../../../../stores/LanguageStore";
import {
  IconDeviceFloppy,
  IconExternalLink,
  IconHelp,
  IconRefreshDot,
  IconVideo,
} from "@tabler/icons-react";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  getResellerVideoUrl,
  updateResellerVideoUrl,
} from "../../../../api/ResellerAPI";
import { useSessionStore } from "../../../../stores/UserStore";
import { notifications } from "@mantine/notifications";
import ImageGetter from "../../resellers/ImageGetter";

const names = {
  home: [
    "HomeWelcomeDemo",
    "HomeSenderEmailConnectDemo",
    "HomeLinkedinAccountConnectDemo",
    "HomeListCreationDemo",
    "HomeTemplateCreationDemo",
    "HomeCampaignCreationDemo",
  ],
  list: [
    "ListsScrapingSourcesTutorial",
    "ListsScrapeLinkedinTutorial",
    "ListsScrapeGoogleMapsTutorial",
    "ListsScrapeLinkedinJobPostPublishersTutorial",
    "ListsScrapeLinkedinLikersCommentersTutorial",
    "ListsManualImportTutorial",
  ],
  linkedin: [
    "ListsLinkedinScrapeLinkedinTutorial",
    "ListsLinkedinScrapeJobPostPublishersTutorial",
    "ListsLinkedinScrapingErrorTutorial",
  ],
  gmaps: ["ListsGoogleMapsScrapeGoogleMapsTutorial"],
  sender: ["IntegrationOVHTutorial", "IntegrationLinkedinConnectTutorial"],
  prm: ["LeadsTrackingZapierMakeSyncTutorial"],
};

const ResellersVideos = () => {
  const lang = useLanguage((s) => s.language);
  const { resellerId } = useParams();
  const [loading, setLoading] = useState(true);
  const [videos, setVideos] = useState([]);
  const [updating, setUpdating] = useState(false);
  const [thumbnails, setThumbnails] = useState({});

  const handleLinkClick = (item) => {
    let link = document.querySelector(`[name="${item}"]`).value;

    if (link) {
      window.open(link, "_blank");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const fd = new FormData(e.target);
    const data = Object.fromEntries(fd);


    console.log(data);


    let formData = new FormData();
    formData.append("videos", JSON.stringify(Object.keys(data).map((key) => ({ name: key, url: data?.[key] || "" }))));
    Object.keys(thumbnails).forEach((key) => {
      if (thumbnails[key])
        formData.append(`thumbnails[${key}]`, thumbnails[key]);
    });


    console.log(Object.fromEntries(formData));

    setUpdating(true);
    updateResellerVideoUrl({
      reseller_id: resellerId,
      formData,
    })
      .then((r) => {
        notifications.show({ message: lang.resellers.videos.saved });
      })
      .finally(() => setUpdating(false));
  };

  const getVideoImagePlacement = (key) => {
    function getName() {
      if (key === "HomeWelcomeDemo") {
        return "HomeWelcomeDemo";
      }
      if (key === "ListsGoogleMapsScrapeGoogleMapsTutorial") {
        return "ListsGoogleMapsScrapeTutorial";
      }
      if (
        [
          "IntegrationOVHTutorial",
          "IntegrationLinkedinConnectTutorial",
          "LeadsTrackingZapierMakeSyncTutorial",
        ].find((x) => x === key)
      ) {
        return key;
      }
      if (key.includes("Home")) {
        return "HomeDemo";
      }
      if (key.includes("ListsScrap")) {
        return "ListsScrapingTutorial";
      }
      if (key.includes("ListsLinkedinScrap")) {
        return "ListsLinkedinScrapeTutorial";
      }
    }

    return `/video_img/${getName()}.jpg`;
  };

  useEffect(() => {
    if (loading) {
      getResellerVideoUrl(resellerId)
        .then((r) => {
          setVideos(r.data.videos);
        })
        .finally(() => setLoading(false));
    }
  }, [loading]);

  console.log(videos);


  return (
    <Accordion variant="filled" mt={"md"} radius={"md"}>
      <Accordion.Item value="advanced" bg={"#fff"} radius={"md"} px={"lg"}>
        <Accordion.Control bg={"#fff"}>
          <Group>
            <IconVideo />
            <Text size="xl" fw={700}>
              {lang.resellers.videos.title}
            </Text>
          </Group>
        </Accordion.Control>
        <Accordion.Panel>
          <Blockquote p={"sm"} mb={16} radius={"md"}>
            <Text size="lg">{lang.resellers.videos.text}</Text>
            <Text size="lg" fw={600} mt={4}>
              {lang.resellers.videos.info}
            </Text>
            <Text size="lg" fw={600} mt={4}>
              {lang.resellers.videos.youtube_info}
            </Text>
          </Blockquote>
          {loading ? (
            <Stack pos={"relative"} h={200}>
              <LoadingOverlay visible />
            </Stack>
          ) : (
            <Stack component={"form"} onSubmit={handleSubmit} pos={"relative"}>
              <LoadingOverlay visible={updating} />
              {Object.keys(names).map((group) => {
                let items = names[group];

                return (
                  <>
                    <Divider
                      label={lang.resellers.videos[group]}
                      styles={{ label: { fontSize: 16 } }}
                    />

                    <SimpleGrid
                      cols={4}
                      spacing={"xl"}
                      mb={16}
                    >
                      {items.map((item) => (
                        <Paper key={item} withBorder p={"md"} pos={"relative"}>

                          <HoverCard key={item} position="top" closeDelay={0}>
                            <HoverCard.Target>
                              <ThemeIcon pos={"absolute"} top={4} right={4} color="secondary" variant="light" radius={"xl"}>
                                <IconHelp />
                              </ThemeIcon>
                            </HoverCard.Target>

                            <HoverCard.Dropdown p={8} style={{ border: "1px solid #aaa" }}>
                              <Image
                                maw={500}
                                src={getVideoImagePlacement(item)}
                              />
                            </HoverCard.Dropdown>
                          </HoverCard>
                          <TextInput
                            name={item}
                            defaultValue={
                              videos.find((x) => x.name === item)?.url
                            }
                            label={lang.resellers.videos?.[item]?.replace?.(
                              "#",
                              useSessionStore.getState().reseller?.name
                            )}
                            flex={1}
                            size="md"
                            mb={8}
                            type="url"
                            placeholder={lang.resellers.videos?.[
                              item
                            ]?.replace?.(
                              "#",
                              useSessionStore.getState().reseller?.name
                            )}
                            rightSection={
                              <ActionIcon
                                variant="light"
                                onClick={() => handleLinkClick(item)}
                              >
                                <IconExternalLink size={18} />
                              </ActionIcon>
                            }
                          />
                          <ImageGetter
                            tip_src={lang.resellers.thumbnail}
                            title={lang.resellers.thumbnail}
                            // name={`${item}_thumbnail`}
                            types={["JPG", "JPEG", "PNG"]}
                            defaultPreview={videos.find((x) => x.name === item)?.thumbnail_url || null}
                            setFile={(f) => setThumbnails((t) => ({ ...t, [item]: f }))}
                            w={"100%"}
                          />
                        </Paper>
                      ))}
                    </SimpleGrid>
                  </>
                );
              })}
              <Group justify="center" mt={"lg"} gap={"xl"}>
                <Button
                  type="reset"
                  variant="light"
                  leftSection={<IconRefreshDot />}
                  size="md"
                >
                  {lang.prm.toolbar.reset}
                </Button>
                <Button
                  type="submit"
                  leftSection={<IconDeviceFloppy />}
                  size="md"
                >
                  {lang.global.save}
                </Button>
              </Group>
            </Stack>
          )}
        </Accordion.Panel>
      </Accordion.Item>
    </Accordion>
  );
};

export default ResellersVideos;
